import '../scss/_global.scss';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import LayoutContextContainer from '@/components/layout-context-container';
import initOneTrustScrollLockWatcher from '@/util/oneTrustScrollLockWatcher';

// const DtcLayoutFull = dynamic(() => import('@/layouts/dtc-layout-full'));
const HcpLayoutFull = dynamic(() => import('@/layouts/hcp-layout-full'));

export default function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    initOneTrustScrollLockWatcher();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof window.__loadOneTrustScripts === 'function') {
      window.__loadOneTrustScripts();
    }

    window.dispatchEvent(new CustomEvent('OneTrustReady'));
  }, [router.asPath]);

  // If the page defines its own layout, use it and allow full control of props
  const getLayout = Component.getLayout;
  if (typeof getLayout === 'function') {
    return (
      <LayoutContextContainer>
        {getLayout(<Component {...pageProps} />)}
      </LayoutContextContainer>
    );
  }

  // Otherwise, support passing props from the page via static hooks
  const layoutProps = typeof Component.getLayoutProps === 'function'
    ? Component.getLayoutProps(pageProps, router)
    : (Component.layoutProps || {});

  const Layout = HcpLayoutFull; // default to HCP layout, removed DTC layout due to sites split

  return (
    <LayoutContextContainer>
      <Layout {...layoutProps}>
        <Component {...pageProps} />
      </Layout>
    </LayoutContextContainer>
  );
}